import { render, staticRenderFns } from "./CreateFormLotteryRecord.vue?vue&type=template&id=0257fbc9&scoped=true"
import script from "./CreateFormLotteryRecord.vue?vue&type=script&lang=js"
export * from "./CreateFormLotteryRecord.vue?vue&type=script&lang=js"
import style0 from "./CreateFormLotteryRecord.vue?vue&type=style&index=0&id=0257fbc9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0257fbc9",
  null
  
)

export default component.exports